import React from "antd";

import { Dropdown } from 'antd';
import {DownloadOutlined, DownOutlined} from "@ant-design/icons";

export const DownloadDropDown = ({onDownload, disabled}) => {

    const items = [
        {
            label: 'CSV',
            key: 'csv',
        },
        {
            label: 'Excel',
            key: 'xlsx',
        },
        {
            label: 'Parquet',
            key: 'parquet',
        },
        {
            label: 'TSV',
            key: 'tsv',
        },
        {
            label: 'JSON',
            key: 'json',
        },
    ];
    const menuProps = {
        items,
        onClick: (e) => {
            onDownload(e.key);
        },
    };


    return <Dropdown.Button menu={menuProps} icon={<DownOutlined />} disabled={disabled}><DownloadOutlined />Export</Dropdown.Button>


}